// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mos-info-card[data-v-56b1bdbf]{background-color:var(--c-black);border-radius:0;box-shadow:none;color:var(--c-white);font-size:15px;line-height:20px;min-width:225px;padding:10px;position:relative}.mos-info-card__address[data-v-56b1bdbf]{margin-bottom:20px}.mos-info-card__link[data-v-56b1bdbf]{font-size:15px!important;line-height:20px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
